document.addEventListener('DOMContentLoaded', function () {
    const uploadFields = document.getElementsByClassName('custom-file-input')

    Array.from(uploadFields).forEach((uploadField) => {
        uploadField.addEventListener('change', function (event) {
            uploadField.nextElementSibling.innerHTML = event.target.value
        })
    })
})
